import { __decorate, __rest } from "tslib";
/**
 *  中标车辆
 */
import React, { Component } from 'react';
import { Table, Form, Button, Row, Col, DatePicker, Select } from 'antd';
import { connect } from '@souche-f2e/muji';
import { TableContainer, showInfo, UnitSearch, OperateShowMore, BuyerDistributor } from '@/components';
import { dispatch } from '@@/store';
import { dealListValueShow, dealValueShow, getDataType, thousandBitSeparator } from '@/shared/functions';
import { fontEndConfig, showCarDetail } from '@/shared/utils';
import moment from 'moment';
import { useOperate } from '@/pages/OrderManage/_component/operateColumn';
import { dealTableScroll } from './function';
const mapStateToProps = (rootState) => ({
    carState: rootState.carState,
});
// @ts-ignore
let WinBiddingTable = class WinBiddingTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clipped: [
                { dataIndex: 'goodsName' },
                { dataIndex: 'carVin' },
                { dataIndex: 'carLicense' },
                { dataIndex: 'carLocation' },
                { dataIndex: 'buyerTypeName' },
                { dataIndex: 'buyerName' },
                { dataIndex: 'sellerName' },
                { dataIndex: 'createTime' },
            ],
            colums: [
                {
                    title: props.isOrder ? '订单信息' : '车辆信息',
                    dataIndex: 'carMag',
                    fixed: 'left',
                    width: 400,
                    render: (data, rowData, index) => {
                        const { firstImage, goodsName, goodsId, carVin, carLicense, carLocation, rankLevel, rankDesc, reportType, orderId } = rowData;
                        return (<div className={'lefe_right_layout'}>
                <div className={'img_item'}>
                  <img src={firstImage} alt={goodsName}/>
                </div>
                <div>
                  {props.isOrder && <div>
                      订单号：{orderId || fontEndConfig.noValueReplace}
                    </div>}
                  <div>
                    <a onClick={() => {
                            showCarDetail(goodsId);
                        }}>
                      {goodsName}
                    </a>
                  </div>
                  <div>{`VIN码：${dealValueShow(carVin)}`}</div>
                  <div>
                    {reportType === 1 &&
                            <img className={'report_268v'} src={require('@/assets/report/268v_2.png')} alt="268v"/>}
                    <div className={'tag_item'}>{carLicense}</div>
                    <div className={'tag_item'}>{carLocation}</div>
                    <div className={'tag_item'}>
                      {dealValueShow((rankLevel + rankDesc) === 'undefined' ? fontEndConfig.noValueReplace : (rankLevel + rankDesc), false, fontEndConfig.noValueReplace)}
                    </div>
                  </div>
                </div>
              </div>);
                    },
                },
                {
                    title: '买卖家信息',
                    dataIndex: 'buyerMsg',
                    width: 250,
                    render: (data, record, index) => {
                        return (<div>
                <div>{`买家类型：${record.buyerTypeName}`}</div>
                <BuyerDistributor record={record}/>
                <div>
                  <span>卖家经销商：</span>
                  <a onClick={() => {
                            showInfo('seller', record.sellerCode);
                        }}>
                    <span>{record.sellerName}</span>
                  </a>
                </div>
                <div>{`中标时间：${record.createTime}`}</div>
              </div>);
                    },
                },
                {
                    title: '价格信息',
                    dataIndex: 'priceMsg',
                    className: 'tableColumn__addYuan',
                    width: 300,
                    render: (data, record, index) => {
                        return (<div>
                <div>{`中标价：${thousandBitSeparator(record.sellerPriceYuanUnit)}`}</div>
                <div>{`合手价：${thousandBitSeparator(record.totalPriceYuanUnit)}`}</div>
                <div style={{
                            fontSize: '10px',
                        }}>
                  {`佣金：${thousandBitSeparator(record.brokerageYuanUnit)}`}
                  &nbsp;&nbsp;
                  {`服务费：${thousandBitSeparator(record.commissionYuanUnit)}`}
                </div>
              </div>);
                    },
                },
                {
                    title: '中标信息',
                    dataIndex: 'winMsg',
                    className: 'tableColumn__addYuan',
                    width: 200,
                    render: (data, record, index) => {
                        let bidPlatformName;
                        if (record.actionType === 10 && record.orderTag === 1) {
                            bidPlatformName = '车易拍';
                        }
                        else {
                            bidPlatformName = '自有平台';
                        }
                        return (<div>
                <div style={{ marginBottom: '5px' }}>{`中标平台：${bidPlatformName}`}</div>
                <div>
                  <span>成交信息：</span>
                  <a onClick={() => {
                            this.showTransferDetail(record.goodsId);
                        }}>
                    查看
                  </a>
                </div>
              </div>);
                    },
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    width: 100,
                    fixed: 'right',
                    render: (text, record, index) => (<OperateShowMore>
              {useOperate({
                        pageIdentification: 'winBiddingcar',
                        record,
                        orderCallback: () => {
                            const { pageIndex } = this.props.carState;
                            this.changePage(pageIndex);
                            this.props.isOrder ? dispatch.winBiddingCar.getOrderCountInfoApi({}) : dispatch.carState.getEveryStateCarNum({});
                        },
                    })}
              {!props.isOrder && <a onClick={() => {
                        dispatch.router.push({
                            path: '/carManage/DealDetail',
                            query: {
                                id: record.auctionId,
                            },
                        });
                    }}>
                  处理详情
                </a>}
              {!props.isOrder && <a onClick={() => {
                        dispatch.router.push({
                            path: '/carManage/OfferCeneList',
                            query: {
                                id: record.auctionId,
                                gd: record.goodsId,
                            },
                        });
                    }}>
                  竞拍记录
                </a>}
            </OperateShowMore>),
                },
            ],
            transferList: [
                {
                    key: 'contactAddress',
                    label: '看车地址',
                },
                {
                    key: 'transferType',
                    label: '过户方式',
                    render(transferType) {
                        let transferTypeStr = transferType;
                        switch (transferType) {
                            case 1:
                                transferTypeStr = '车易拍过户';
                                break;
                            case 2:
                                transferTypeStr = '卖家过户';
                                break;
                            case 3:
                                transferTypeStr = '买家过户';
                                break;
                        }
                        return <span>{transferTypeStr}</span>;
                    },
                },
                {
                    key: 'transferAddress',
                    label: '指定过户地址',
                    render(transferAddress) {
                        return (<span>
                {transferAddress === fontEndConfig.noValueReplace ? '否' : '是'}
              </span>);
                    },
                },
                {
                    key: 'transferAddress',
                    label: '过户地址',
                },
                {
                    key: 'invoicePrice',
                    label: '指定开票',
                    render(invoicePrice) {
                        return (<span>
                {getDataType(invoicePrice) === 'Number' ?
                            invoicePrice === -1 ? '不需要' : '需要'
                            :
                                invoicePrice}
              </span>);
                    },
                },
                {
                    key: 'nonlocalTag',
                    label: '过户类型',
                    render(nonlocalTag) {
                        let nonlocalTagStr = nonlocalTag;
                        switch (nonlocalTag) {
                            case 1:
                                nonlocalTagStr = '本地';
                                break;
                            case 2:
                                nonlocalTagStr = '外迁';
                                break;
                            case 3:
                                nonlocalTagStr = '不限';
                                break;
                        }
                        return <span>{nonlocalTagStr}</span>;
                    },
                },
                {
                    key: 'localProcedures',
                    label: '过户手续（本地）',
                    render(localProcedures) {
                        const listVal = {
                            1: '原购车发票',
                            2: '过户票',
                            3: '原过户票',
                            4: '原登记证',
                            5: '原行驶本',
                            6: '卖家身份证',
                            7: '买家身份证',
                            8: '变更后行驶本',
                            9: '变更后登记证',
                            11: '协议',
                            12: '服务授权书',
                            13: '档案',
                        };
                        const localProceduresList = localProcedures.split(',');
                        const valShow = localProceduresList.map((val) => {
                            return listVal[val];
                        });
                        return <span>{valShow.join(' ') || localProcedures}</span>;
                    },
                },
                {
                    key: 'emigrateProcedures',
                    label: '过户手续（外迁）',
                    render(emigrateProcedures) {
                        const listVal = {
                            1: '原购车发票',
                            2: '过户票',
                            3: '原过户票',
                            4: '原登记证',
                            5: '原行驶本',
                            6: '卖家身份证',
                            7: '买家身份证',
                            8: '变更后行驶本',
                            9: '变更后登记证',
                            11: '协议',
                            12: '服务授权书',
                            13: '档案',
                        };
                        const emigrateProceduresList = emigrateProcedures.split(',');
                        const valShow = emigrateProceduresList.map((val) => {
                            return listVal[val];
                        });
                        return <span>{valShow.join(' ') || emigrateProcedures}</span>;
                    },
                },
            ],
            unitList: [
                {
                    label: '买家经销商名称',
                    key: 'buyerName',
                },
                {
                    label: '买家经销商电话',
                    key: 'buyerPhone',
                },
            ],
            userTypeList: [
                {
                    label: '全部',
                    key: '',
                },
                {
                    label: '网络',
                    key: 1,
                },
                {
                    label: '现场',
                    key: 0,
                },
            ],
            globalSearch: {},
            privateSearch: {
                unitSearch: undefined,
            },
        };
    }
    showTransferDetail(goodsId) {
        const list = this.state.transferList;
        dispatch.session.getTransfer({
            params: {
                goodsId,
            },
            callback: (data = {}) => {
                const valData = dealListValueShow({
                    gistData: list,
                    data: [data],
                })[0];
                showInfo('userDefine', {
                    title: '成交信息',
                    describle: '',
                    content: () => {
                        return (<div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}>
                {list.map((item, index) => {
                            return (<Form.Item style={{
                                width: '100%',
                                marginBottom: 0,
                            }} labelCol={{
                                span: 8,
                                offset: 2,
                            }} wrapperCol={{
                                span: 12,
                            }} labelAlign={'left'} colon={false} key={index} label={item.label}>
                        {item.render ? item.render(valData[item.key]) : <span>{valData[item.key]}</span>}
                      </Form.Item>);
                        })}
                {list.length === 0 && (<span>暂无</span>)}
                <Button style={{
                            marginTop: '20px',
                        }} type={'primary'} onClick={() => {
                            dispatch.info.RESET_HIDE();
                        }}>
                  确定
                </Button>
              </div>);
                    },
                });
            },
        });
    }
    // desc显示表格内容
    componentDidMount() {
        this.props.isOrder ? dispatch.winBiddingCar.getOrderCountInfoApi({}) : dispatch.carState.getEveryStateCarNum({});
        this.searchData(this.props.search);
    }
    changePage(index) {
        dispatch.carState.updateWinBiddingCarTable(index);
    }
    search() {
        const { globalSearch, privateSearch } = this.state;
        const { unitSearch } = privateSearch, otherPrivate = __rest(privateSearch, ["unitSearch"]);
        const params = Object.assign(Object.assign(Object.assign({}, globalSearch), otherPrivate), unitSearch);
        dispatch.carState.SET_STATE({
            searchData: params,
        });
        dispatch.carState.updateWinBiddingCarTable(1);
    }
    searchData(searchData) {
        const { isOrder } = this.props;
        const { vin } = searchData, otherSearch = __rest(searchData, ["vin"]);
        this.setState({
            globalSearch: isOrder ? searchData : Object.assign(Object.assign({}, otherSearch), { vinCode: vin }),
        }, () => {
            this.search();
        });
    }
    render() {
        const { tableData, isLoading, pageIndex, pageSize, tableTotal, searchData } = this.props.carState;
        const { colums, clipped, unitList, userTypeList } = this.state;
        const { dealColumns, scrollX } = dealTableScroll(colums);
        return (<React.Fragment>
        <TableContainer hasExport={true} exportObj={{
            type: 'order',
            params: Object.assign(Object.assign({}, searchData), { totalCount: tableTotal, exportType: 'order_win_bidding' }),
            fileName: this.props.isOrder ? '订单管理-中标' : '车辆管理-中标',
            allow: this.props.isOrder ? 'psgjb-orderwinbid-export' : 'psgjb-carpendzhongbiao-export',
        }}>
          <Row gutter={16} align={'middle'} type={'flex'} justify={'start'} style={{
            marginRight: '100px',
        }}>
            <Col span={6}>
              <UnitSearch queryList={unitList} onChange={(val) => {
            const searchData = this.state.privateSearch;
            const unitSearch = {};
            if (val) {
                const [searchKey, searchContent] = val.split('_');
                unitSearch[searchKey] = searchContent;
            }
            this.setState({
                privateSearch: Object.assign(Object.assign({}, searchData), { unitSearch }),
            }, () => {
                this.search();
            });
        }}/>
            </Col>
            <Col span={8}>
              <Form.Item label={'中标时间'} colon={false} className={'search_time_label_border form_date_width_100'}>
                <DatePicker.RangePicker placeholder={['开始时间', '结束时间']} className={'width-100'} disabledDate={(currentDate) => {
            const now = moment();
            return currentDate > now;
        }} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} onChange={(dates) => {
            let [startTime, endTime] = dates;
            startTime && (startTime = startTime.format('YYYY-MM-DD'));
            endTime && (endTime = endTime.format('YYYY-MM-DD'));
            const { privateSearch } = this.state;
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { tradeDateStar: startTime, tradeDateEnd: endTime }),
            }, () => {
                this.search();
            });
        }}/>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Select style={{
            width: '100%',
        }} placeholder={'请选择买家类型'} onChange={(val) => {
            const { privateSearch } = this.state;
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { buyerTypeCode: val }),
            }, () => {
                this.search();
            });
        }}>
                {userTypeList.map(({ label, key }) => {
            return (<Select.Option value={key} key={key}>{label}</Select.Option>);
        })}
              </Select>
            </Col>
          </Row>
          <Table className="draw_table_all_border scroll_table" loading={isLoading} columns={dealColumns} dataSource={dealListValueShow({
            gistData: [...colums, ...clipped],
            data: tableData,
        })} scroll={{
            x: scrollX,
        }} rowKey={'orderId'} pagination={{
            current: pageIndex,
            pageSize,
            showQuickJumper: true,
            total: tableTotal,
            onChange: this.changePage,
            showTotal: total => `共${total}条`,
        }}/>
        </TableContainer>
      </React.Fragment>);
    }
};
WinBiddingTable.defaultProps = {
    isOrder: false,
};
WinBiddingTable = __decorate([
    connect(mapStateToProps, null, null, { forwardRef: true })
], WinBiddingTable);
export default WinBiddingTable;
